import React from "react"
import CPSOfferFileDrop from "./CPSOfferFileDrop"
import moment from "moment"

const CPSOffer = ({ entry, myUser, statusIndex, reload }) => {
  const isUserCPSLab = () => myUser?.company?.id === entry?.cpsLabID
  const isUserRequestor = () =>
    myUser?.company?.id === entry?.requestorCompanyID
  const isWarehouseUser = myUser?.cpsRole === "Warehouse"

  return (
    <>
      {entry?.offerFileURL &&
      ((entry.statusIndex != statusIndex && isUserCPSLab()) ||
        isUserRequestor()) ? (
        <li
          className={
            "event-list " + (entry?.statusIndex == statusIndex ? "active" : "")
          }
        >
          <a
            href={entry?.offerFileURL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark"
          >
            <div
              className={
                "event-timeline-dot " +
                (entry?.statusIndex == statusIndex ? "bx-fade-right" : "")
              }
            >
              <i className="bx bx-right-arrow-circle font-size-18"></i>
            </div>
            <div className="d-flex">
              <div className="flex-shrink-0 me-3">
                <h5 className="font-size-14">
                  {moment(entry?.dateOfferUploaded).format("DD.MM.YYYY")}{" "}
                  <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                </h5>
              </div>
              <div className="flex-grow-1">
                <div>Offer provided by CPS Lab</div>
              </div>
            </div>
            <div className="d-flex align-items-center mt-3">
              <div style={{ width: "45px" }}>
                <div className="avatar-sm">
                  <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-24">
                    <i className="bx bxs-file-doc" />
                  </span>
                </div>
              </div>
              <div className="ms-4">
                <h5 className="font-size-14 mb-1">CPS Offer</h5>
                <small>Click To Download</small>
                {entry?.price && (
                  <div className="mt-1">
                    <small className="text-muted">
                      Price: {entry.price} {entry.currency}
                    </small>
                  </div>
                )}
                {entry?.deliveryTime && (
                  <div>
                    <small className="text-muted">
                      Delivery: {entry.deliveryTime}
                    </small>
                  </div>
                )}
              </div>
              <div className="text-center ms-4">
                <i className="bx bx-download h3 m-0" />
              </div>
            </div>
          </a>
        </li>
      ) : (
        <>
          {entry?.statusIndex == statusIndex - 1 &&
            entry?.cpsLabID == myUser?.company?.id &&
            !isWarehouseUser && (
              <CPSOfferFileDrop entry={entry} reload={reload} />
            )}

          {entry?.statusIndex == statusIndex - 1 &&
            entry?.cpsLabID == myUser?.company?.id &&
            isWarehouseUser && (
              <li className="event-list active">
                <div className="event-timeline-dot bx-fade-right">
                  <i className="bx bx-right-arrow-circle font-size-18"></i>
                </div>
                <div className="mt-2 alert alert-warning mb-0">
                  <i className="bx bx-info-circle me-2"></i>
                  Only CPS Admin users can upload or change offers. This step is
                  read-only for warehouse users.
                </div>
              </li>
            )}

          {entry?.statusIndex == statusIndex && isUserCPSLab() && (
            <li
              className={
                "event-list " +
                (entry?.statusIndex == statusIndex ? "active" : "")
              }
            >
              <a
                href={entry?.offerFileURL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-dark"
              >
                <div
                  className={
                    "event-timeline-dot " +
                    (entry?.statusIndex == statusIndex ? "bx-fade-right" : "")
                  }
                >
                  <i className="bx bx-right-arrow-circle font-size-18"></i>
                </div>
                <div className="d-flex">
                  <div className="flex-shrink-0 me-3">
                    <h5 className="font-size-14">
                      {moment(entry?.dateOfferUploaded).format("DD.MM.YYYY")}{" "}
                      <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                    </h5>
                  </div>
                  <div className="flex-grow-1">
                    <div>Offer provided by CPS Lab</div>
                  </div>
                </div>
                <div className="d-flex align-items-center mt-3">
                  <p>
                    Please wait. You will be notified as soon as the Customer
                    has accepted the offer.
                  </p>
                </div>
              </a>
            </li>
          )}
        </>
      )}
    </>
  )
}

export default CPSOffer
